import { TUseAsyncOptionsParams } from '@/shared/components/ui/form/components/searchable-select/hooks/use-async-options/use-async-options.types';
import { useOptions } from '@/shared/components/ui/form/components/searchable-select/hooks/use-options/use-options';
import { NameFilterBuilder } from '@/shared/filters/entity-filters/name-filter-builder/name-filter-builder';
import { useDirectFilter } from '@/shared/filters/hooks/use-direct-filter/use-direct-filter';

export const useAsyncOptions = <TData, TDataShape>({
  debouncedSearch,
  rtkQueryArgs,
  useRTKQuery,
  transformData,
  value,
  getItemId,
  disableNameLower = false,
  searchField,
  disableSort,
}: TUseAsyncOptionsParams<TData, TDataShape>) => {
  const nameFilter = useDirectFilter(
    new NameFilterBuilder({
      disableFieldMapping: disableNameLower,
      field: searchField,
    }),
    {
      name: debouncedSearch,
    },
  );
  const filter = { ...nameFilter, ...rtkQueryArgs?.filter };
  const { data, isLoading, isFetching } = useRTKQuery({
    ...rtkQueryArgs,
    filter: debouncedSearch ? filter : rtkQueryArgs?.filter,
  });

  const loading = isLoading || isFetching;
  const options = transformData(data);

  const { isSelected, groupedOptions } = useOptions({
    options,
    getItemId,
    value,
    disableSort,
  });

  return {
    options: groupedOptions,
    loading,
    isSelected,
  };
};
